import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    position: sticky;
    top: 0;
    background-color: ${colors.white};
    width: 100%;
    flex-direction: column;
    z-index: 1199;
  `,
};

export default styles;
